import React, { useEffect, useMemo, useRef, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CreditCardForm from "../../../v1/components/CreditCardForm"
import { prepareCheckoutObj } from "../../../v1/helpers/affirmHelper"
import { connect } from "react-redux"
import {
  createPaymentMethod,
  getPaymentMethods,
  setPaymentDefault
} from "../../../v1/actions/paymentMethods"
import { useTranslation, withTranslation } from "react-i18next"
import { setupPaypalBraintree } from "../../../shared_component/utils/setupBraintree"
import { PAYMENT_METHODS } from "../../../v1/constants/application"
import Affirm_Logo from "../../../images/Affirm_Logo.svg"
import { Card, Icon, Image, Input, Button } from "semantic-ui-react"
import LockIcon from "../../../images/LockIcon.svg"
import Visa from "../../../images/Visa.svg"
import Maestro from "../../../images/Maestro.svg"
import Mastercard from "../../../images/Mastercard.svg"
import ReactSVG from "react-svg"
import PayPalLogo from "../../../images/PayPalLogo.svg"
import { obfuscateEmail } from "../../../shared_component/utils/stringHelpers"
import { createOrder } from "../../../v1/actions/orders"
import { AFFIRM, BRAINTREE } from "../../../v1/constants/tires"
import { updateInfo } from "../../../v1/actions/user"
import InfoIcon from "../../../images/info-Icon.svg"
import CloseIcon from "../../../images/close-icon.svg"
import { routerPaths } from "../../../v1/constants/paths"
import PaymentMethod from "../../../v1/components/PaymentMethods/PaymentMethod"
import { faClose } from "@fortawesome/pro-solid-svg-icons"
import DiscountRibbon from "./SelectShop/DiscountRibbon"
import { createMembership } from "../../../v1/actions/membership"
import store from "../../../shared_component/utils/configureStore"
import { ReactComponent as InfoIconComponent } from "../../../images/info-Icon.svg"
import { ReactComponent as TickIcon } from "../../../images/tick-icon-dynamic.svg"
import Notifications from "../../../v1/components/Notifications"

const AddPaymentDetails = ({
  user,
  createPaymentMethod,
  getPaymentMethods,
  setPaymentDefault,
  cart,
  updateInfo,
  asModal = false,
  closeModalHandler = () => {},
  braintreePaymentMethods,
  history,
  location,
  membershipData,
  createMembership
}) => {
  const { t } = useTranslation("tirePayment")
  const creditCardRef = useRef()
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null)
  const [paypalPayment, setPaypalPayment] = useState(null)
  const [showPaypalButton, setShowPaypalButton] = useState(true)
  const [affirmPaymentDetails, setAffirmPaymentDetails] = useState(null)
  const [showAddPaymentMethod, setShowAddPaymentMethod] = useState(false)
  const [validPaymentMethod, setValidPaymentMethod] = useState(false)
  const [validCard, setValidCard] = useState(null)
  const [addCardSuccessful, setAddCardSuccessful] = useState(false)
  const [phone, setPhone] = useState("")
  const [phoneChanged, setPhoneChanged] = useState(false)
  const [loading, setLoading] = useState(false)
  const [membershipActivated, setMembershipActivated] = useState(false)
  const activateMembership = new URLSearchParams(location?.search).get("activate_membership")

  const handlePhone = (e) => {
    setPhone(e.target.value)
  }

  useEffect(() => {
    loadPaymentData()
  }, [])

  useEffect(() => {
    if (validCard && selectedPaymentMethod === 0) {
      setValidPaymentMethod(true)
    } else {
      setValidPaymentMethod(false)
    }
  }, [validCard])

  const loadPaymentData = async () => {
    if (!braintreePaymentMethods || braintreePaymentMethods.length == 0) {
      await getPaymentMethods(user)
    }
  }

  const setupData = async () => {
    const paypalCheckoutInstance = await setupPaypalBraintree()
    paypalCheckoutInstance
      .loadPayPalSDK({
        vault: true,
        intent: "tokenize",
        "disable-funding": "card,credit"
      })
      .then(() => {
        window.paypal
          .Buttons({
            style: {
              disableMaxWidth: true,
              align: "center",
              height: 50
            },
            createBillingAgreement: function () {
              return paypalCheckoutInstance.createPayment({
                flow: "vault",
                intent: "tokenize"
              })
            },
            onApprove: (data) => {
              return paypalCheckoutInstance.tokenizePayment(data, async (err, payload) => {
                setPaypalPayment(payload)
                setShowPaypalButton(false)
                await createPaymentMethod(user, payload.nonce, PAYMENT_METHODS.PAYPAL, true)
              })
            },
            onError: function (err) {
              console.error("PayPal error", err)
            }
          })
          .render("#paypal-custom-btn")
      })
  }

  useEffect(() => {
    setValidPaymentMethod(false)

    if (selectedPaymentMethod === 1) {
      if (showPaypalButton) {
        setupData()
        return
      } else if (paypalPayment) {
        setValidPaymentMethod(true)
      }
    }

    if (selectedPaymentMethod === 2) {
      setValidPaymentMethod(true)
    }

    if (!user.cellPhone && phone.length !== 10) {
      setValidPaymentMethod(false)
    }

    if (paypalPayment && showPaypalButton) {
      setShowPaypalButton(false)
    }
  }, [selectedPaymentMethod, showPaypalButton])

  const handleAffirmPayment = async () => {
    const checkoutObj = prepareCheckoutObj(user, cart[0])
    window.affirm.checkout(checkoutObj)

    await window.affirm.checkout.open({
      onFail: (a) => {
        setSelectedPaymentMethod(null)
      },
      onSuccess: (a) => {
        setAffirmPaymentDetails(a)
        setValidPaymentMethod(true)
      }
    })
  }

  const confirmServiceRequest = async () => {
    try {
      if (!user.cellPhone) {
        await updateInfo({ cellPhone: phone || creditCardRef.current.phoneNumber() })
      }

      if (selectedPaymentMethod === 0) {
        creditCardRef.current.addNewCard()
      } else if (selectedPaymentMethod === 1) {
        cart[0].payment_type = BRAINTREE
        if (activateMembership) {
          upgradeMembership()
          return
        }
        if (asModal) {
          closeModalHandler()
        } else {
          history.push({
            pathname: routerPaths.reviewRequest
          })
        }
      } else if (selectedPaymentMethod === 2) {
        cart[0].payment_type = AFFIRM
        if (asModal) {
          closeModalHandler()
        } else {
          history.push({
            pathname: routerPaths.reviewRequest
          })
        }
      } else {
        cart[0].payment_type = BRAINTREE
        if (activateMembership) {
          upgradeMembership()
          return
        }
        if (asModal) {
          closeModalHandler()
        } else {
          history.push({
            pathname: routerPaths.reviewRequest
          })
        }
      }
    } catch (error) {
      Notifications.error({
        title: t("error"),
        message: error.message ? error.message : error,
        position: "tr",
        autoDismiss: 5,
        action: {
          label: "Dismiss"
        }
      })
    }
  }

  useEffect(() => {
    if (addCardSuccessful) {
      cart[0].payment_type = BRAINTREE
      if (activateMembership) {
        upgradeMembership()
        return
      }
      if (asModal) {
        closeModalHandler()
      } else {
        history.push({
          pathname: routerPaths.reviewRequest
        })
      }
    }
  }, [addCardSuccessful])

  const membership = useMemo(() => {
    if (!membershipData?.length) return null
    return [...membershipData].find((plan) => plan.name === "Premium")
  }, [membershipData])

  const phoneNumber = () => (
    <div className="phone-form">
      <label htmlFor="phone" className="required-field">
        {t("mobilePhoneNumber")}
      </label>
      <Input
        id="phone"
        required
        type="text"
        pattern="\d*"
        placeholder="E.g. 3456781236"
        value={phone}
        onChange={handlePhone}
        maxLength={10}
        icon={
          phone.length > 0 && (
            <ReactSVG
              className="icon__absolute"
              src={CloseIcon}
              onClick={() => {
                setPhone("")
              }}
            />
          )
        }
        error={phoneChanged && phone.length !== 10}
        onBlur={() => setPhoneChanged(true)}
      />
    </div>
  )

  const handlePaymentItemClick = async (evt) => {
    if (!evt.value.default) {
      const res = await setPaymentDefault(user, evt.value.token)
      if (res?.()?.result) {
        closeModalHandler()
      }
    }
  }

  const addPaymentMethods = async () => {
    setShowAddPaymentMethod((prev) => !prev)
  }

  const estimatedTotal = cart?.[0]?.estimated_total || 0
  const showAffirm = user && user.country != "ca" && estimatedTotal > 50

  const upgradeMembership = async () => {
    try {
      const currentMembership = membership || {}
      currentMembership.acceptedPassengerVehicleClause = true
      currentMembership.acceptedTermsAndConditions = true
      setLoading(true)

      const res = await createMembership({
        plan: currentMembership
      })

      const data = res()
      setLoading(false)

      if (data.result) {
        setMembershipActivated(true)
        store.dispatch(
          Notifications.success({
            title: "Success",
            message: t("membership:membershipUpdateSuccessMessage"),
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
      } else {
        store.dispatch(
          Notifications.error({
            title: t("membershipUpgradeModal:errorNotificationTitle"),
            message: `${data.error || t("membershipUpgradeModal:errorNotificationMessage")}`,
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
      setMembershipActivated(false)
    }
  }

  const replaceHistoryAndGoForward = (route) => {
    history.replace({
      pathname: route
    })
    history.go(-1)
    setTimeout(
      () =>
        history.replace({
          pathname: route
        }),
      0
    )
  }

  if (membershipActivated) {
    return (
      <Card className="service-card service-card-activated" raised={true}>
        <TickIcon color="#059669" width={50} height={50} className="tick-icon-centered" />

        <p className="membership-activated-title">Membership activated!</p>

        <div className="info-box">
          <InfoIconComponent width={31} />
          <p className="info-box-text">
            Service charges will be processed separately after you approve the work at the shop.
          </p>
        </div>

        <div className="action_button action-button-column">
          <Button
            className="primary-button"
            onClick={() => replaceHistoryAndGoForward(routerPaths.reviewRequest)}
            loading={loading}
          >
            Review service request
          </Button>
        </div>
      </Card>
    )
  }

  return (
    <>
      {(braintreePaymentMethods?.length > 0 || false) && !showAddPaymentMethod ? (
        <div className={`${asModal ? "" : "service-card"}`}>
          <div className="payment-method" style={asModal ? {} : { padding: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p style={{ margin: 0, fontSize: "22px", fontWeight: "bold", color: "#2F2F2F" }}>
                Choose your payment method
              </p>
              {asModal && (
                <FontAwesomeIcon
                  icon={faClose}
                  style={{ marginTop: "10px" }}
                  width={20}
                  height={20}
                  onClick={closeModalHandler}
                />
              )}
            </div>
            {braintreePaymentMethods && braintreePaymentMethods?.length > 0 && (
              <div className="paymentMethodInfoList">
                {braintreePaymentMethods.map((paymentMethod) => {
                  return (
                    <PaymentMethod
                      key={paymentMethod.token}
                      onSetDefault={handlePaymentItemClick}
                      paymentMethod={paymentMethod}
                      hideDelete={true}
                    />
                  )
                })}
              </div>
            )}
            <p className="link-text" onClick={addPaymentMethods}>
              {t("+Add new payment method")}
            </p>
            <Card fluid className="payment-method-info">
              <Image src={LockIcon} className="info-icon" />
              {t("Payment_info_protected")}
            </Card>
          </div>
          {activateMembership !== null && (
            <div className="action_button column-gap-16">
              <Button className="primary-button" onClick={upgradeMembership} loading={loading}>
                Confirm ${membership.price} charge
              </Button>
              <p style={{ margin: 0, textDecoration: "underline" }}>Cancel</p>
            </div>
          )}
        </div>
      ) : (
        <div
          className={`add-payment-details ${asModal ? "" : "service-card"}`}
          style={asModal ? {} : { margin: "16px", padding: "16px" }}
        >
          {asModal && (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p style={{ margin: 0, fontSize: "22px", fontWeight: "bold", color: "#2F2F2F" }}>
                Add a new payment method
              </p>
              <FontAwesomeIcon
                icon={faClose}
                style={{ marginTop: "10px" }}
                width={20}
                height={20}
                onClick={closeModalHandler}
              />
            </div>
          )}
          {activateMembership && (
            <DiscountRibbon
              src={InfoIcon}
              children={
                <p style={{ fontFamily: "Inter", fontSize: "14px" }}>
                  <strong>
                    Your payment method will be charged $1.99 today for the membership.
                  </strong>{" "}
                  Service charges will be billed later.
                </p>
              }
            />
          )}
          <div className={`payment-form ${selectedPaymentMethod === 0 ? "" : "bg-white"}`}>
            <div
              className="payment-form-title"
              onClick={() => {
                setSelectedPaymentMethod(0)
              }}
            >
              <div className="select-payment">
                <input
                  type="radio"
                  name="plan"
                  className="select-payment-radio-btn"
                  checked={selectedPaymentMethod === 0}
                />
                <span>Pay with credit card</span>
              </div>
              <div className="rightDiv">
                <Image src={Visa} />
                <Image src={Maestro} />
                <Image src={Mastercard} />
              </div>
            </div>
            {selectedPaymentMethod === 0 && (
              <CreditCardForm
                popup={false}
                serviceRequest={true}
                ref={creditCardRef}
                validCardDetails={setValidCard}
                addCardSuccessful={setAddCardSuccessful}
                showPhone={!user.cellPhone}
                setDefault={true}
              />
            )}
          </div>
          <div className={`payment-form ${selectedPaymentMethod === 1 ? "" : "bg-white"}`}>
            <div
              className="payment-form-title"
              onClick={() => {
                setSelectedPaymentMethod(1)
              }}
            >
              <div className="select-payment">
                <input
                  type="radio"
                  name="plan"
                  className="select-payment-radio-btn"
                  checked={selectedPaymentMethod === 1}
                />
                {!paypalPayment && <span>Pay with PayPal</span>}
                {paypalPayment && (
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <ReactSVG src={`images/paymentLogo/pay_pal_account.svg`} />
                    <span>{obfuscateEmail(paypalPayment.details.email)}</span>
                  </span>
                )}
              </div>
              <div className="rightDiv paypal">
                {!paypalPayment && <Image src={PayPalLogo} />}
                {paypalPayment && (
                  <span style={{ color: "#B83614" }} onClick={() => setShowPaypalButton(true)}>
                    Change
                  </span>
                )}
              </div>
            </div>
            {selectedPaymentMethod === 1 && showPaypalButton && <div id="paypal-custom-btn"></div>}
            {paypalPayment && !user.cellPhone && phoneNumber()}
          </div>
          {showAffirm && (
            <div className={`payment-form ${selectedPaymentMethod === 2 ? "" : "bg-white"}`}>
              <div
                className="payment-form-title"
                onClick={() => {
                  setSelectedPaymentMethod(2)
                }}
              >
                <div className="select-payment">
                  <input
                    type="radio"
                    name="plan"
                    className="select-payment-radio-btn"
                    checked={selectedPaymentMethod === 2}
                  />
                  <span>Pay with Affirm</span>
                </div>
                <div className="rightDiv">
                  <Image src={Affirm_Logo} />
                </div>
              </div>
              {selectedPaymentMethod === 2 && !user.cellPhone && phoneNumber()}
            </div>
          )}
          <span className="payment-protected-info">
            <img src={LockIcon} alt="secure-lock" />
            {t("Payment_info_protected")}
          </span>
          {!activateMembership && (
            <div className="column-gap-16">
              <Button
                fluid
                onClick={(event) => {
                  confirmServiceRequest()
                }}
                disabled={!validPaymentMethod}
                className="primary-button"
              >
                {t("Save card")}
              </Button>

              <Button
                fluid
                basic
                color="black"
                onClick={addPaymentMethods}
                className="secondary-button"
              >
                {t("Cancel")}
              </Button>
            </div>
          )}
          {activateMembership !== null && (
            <div className="action_button column-gap-16">
              <Button
                className="primary-button"
                disabled={!validPaymentMethod}
                onClick={confirmServiceRequest}
                loading={loading}
              >
                Confirm ${membership.price} charge
              </Button>
              <p
                style={{ margin: 0, textDecoration: "underline" }}
                onClick={() => history.goBack()}
              >
                Cancel
              </p>
            </div>
          )}
        </div>
      )}
    </>
  )
}

function mapStateToProps(state, props) {
  const braintreePaymentMethods = Array.isArray(state?.paymentMethods?.braintreePaymentMethods)
    ? state.paymentMethods.braintreePaymentMethods.filter((method) => method?.type !== "ach")
    : []
  const user = state.user
  const cart = user.active_carts
  const activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}
  const activeCart =
    user.active_carts && user.active_carts.find((c) => c.vehicle_id === activeVehicle.id)
  return {
    braintreePaymentMethods,
    user,
    cart,
    activeVehicle,
    activeCart,
    membershipData: state.membershipData.availableMembershipPlans
  }
}

export default connect(mapStateToProps, {
  createPaymentMethod,
  createOrder,
  updateInfo,
  getPaymentMethods,
  setPaymentDefault,
  createMembership
})(withTranslation("tirePayment")(AddPaymentDetails))
